module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "part-title"
  }, [_vm._v("Act II")]), _vm._v(" "), _c('h3', {
    staticClass: "ch-titlea",
    attrs: {
      "id": "lev1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 1. London. A Room in the palace")])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter KING EDWARD, led in sick, QUEEN ELIZABETH, DORSET, RIVERS, HASTINGS, BUCKINGHAM, GREY, and others.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("KING EDWARD: Why, so. Now have I done a good day’s work:—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You peers, continue this united league:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I every day expect an embassage")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("From my Redeemer, to redeem me hence;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And more at peace my soul shall part to heaven,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Since I have made my friends at peace on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Rivers and Hastings, take each other’s hand;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Dissemble not your hatred, swear your love.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("RIVERS: By heaven, my soul is purg’d from grudging hate;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And with my hand I seal my true heart’s love.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("HASTINGS; So thrive I, as I truly swear the like!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD; Take heed you dally not before your king;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Lest He that is the supreme King of kings")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Confound your hidden falsehood, and award")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Either of you to be the other’s end.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("HASTINGS: So prosper I, as I swear perfect love!")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("RIVERS; And I, as I love Hastings with my heart!")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: Madam, yourself is not exempt from this;—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Nor you, son Dorset;—Buckingham, nor you;—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You have been factious one against the other.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Wife, love Lord Hastings, let him kiss your hand;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And what you do, do it unfeignedly.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: There, Hastings; I will never more remember")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Our former hatred, so thrive I and mine!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: Dorset, embrace him;—Hastings, love lord marquis.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DORSET: This interchange of love, I here protest,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Upon my part shall be inviolable.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("HASTINGS: And so swear I.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Embraces Dorset.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("KING EDWARD: Now, princely Buckingham, seal thou this league")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("With thy embracements to my wife’s allies,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And make me happy in your unity.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BUCKINGHAM: Whenever Buckingham doth turn his hate")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Upon your grace "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("[to the queen]")]), _vm._v(", but with all duteous love")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Doth cherish you and yours, God punish me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("With hate in those where I expect most love!")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("When I have most need to employ a friend,")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And most assurèd that he is a friend,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Deep, hollow, treacherous, and full of guile,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Be he unto me!—this do I beg of heaven")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("When I am cold in love to you or yours.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Embracing Rivers &c.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("KING EDWARD: A pleasing cordial, princely Buckingham,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Is this thy vow unto my sickly heart.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("There wanteth now our brother Gloster here,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To make the blessèd period of this peace.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BUCKINGHAM: And, in good time, here comes the noble duke.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter GLOSTER.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("GLOSTER; Good morrow to my sovereign king and queen;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And, princely peers, a happy time of day!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: Happy, indeed, as we have spent the day.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Gloster, we have done deeds of charity;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Made peace of enmity, fair love of hate,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Between these swelling wrong-incensèd peers.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: A blessed labour, my most sovereign lord,—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Among this princely heap, if any here,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("By false intelligence or wrong surmise,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Hold me a foe;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("If I unwittingly, or in my rage,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Have aught committed that is hardly borne")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To any in this presence, I desire")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("To reconcile me to his friendly peace:")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v(" ‘Tis death to me to be at enmity;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I hate it, and desire all good men’s love.—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("First, madam, I entreat true peace of you,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Which I will purchase with my duteous service;—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Of you, my noble cousin Buckingham,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("If ever any grudge were lodg’d between us;—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Of you, and you, Lord Rivers, and of Dorset,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That all without desert have frown’d on me;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Of you, Lord Woodville, and, Lord Scales, of you;—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Dukes, earls, lords, gentlemen;—indeed, of all.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I do not know that Englishman alive")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("With whom my soul is any jot at odds")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("More than the infant that is born to-night:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I thank my God for my humility.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: A holy day shall this be kept hereafter:—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I would to God all strifes were well compounded.—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("My sovereign lord, I do beseech your highness")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To take our brother Clarence to your grace.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: Why, madam, have I off’red love for this,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To be so flouted in this royal presence?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who knows not that the gentle duke is dead?")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[They all start.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You do him injury to scorn his corse.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: Who knows not he is dead! Who knows he is?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: All-seeing heaven, what a world is this!")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("BUCKINGHAM: Look I so pale, Lord Dorset, as the rest?")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("DORSET: Ay, my good lord; and no man in the presence")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But his red colour hath forsook his cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: Is Clarence dead? the order was revers’d.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: But he, poor man, by your first order died,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And that a wingèd Mercury did bear;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Some tardy cripple bore the countermand")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That came too lag to see him burièd.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("God grant that some, less noble and less loyal,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Nearer in bloody thoughts, an not in blood,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Deserve not worse than wretched Clarence did,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And yet go current from suspicion!")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter Stanley.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("STANLEY: A boon, my sovereign, for my service done!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: I pr’ythee, peace: my soul is full of sorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("STANLEY: I Will not rise unless your highness hear me.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: Then say at once what is it thou request’st.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("STANLEY: The forfeit, sovereign, of my servant’s life;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who slew to-day a riotous gentleman")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Lately attendant on the Duke of Norfolk.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("KING EDWARD: Have I a tongue to doom my brother’s death,")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("And shall that tongue give pardon to a slave?")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("My brother kill’d no man,—his fault was thought,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And yet his punishment was bitter death.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who su’d to me for him? who, in my wrath,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Kneel’d at my feet, and bid me be advis’d?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who spoke of brotherhood? who spoke of love?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who told me how the poor soul did forsake")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The mighty Warwick, and did fight for me?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who told me, in the field at Tewksbury,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("When Oxford had me down, he rescu’d me,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And said “Dear brother, live, and be a king”?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who told me, when we both lay in the field")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Frozen almost to death, how he did lap me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Even in his garments, and did give himself,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("All thin and naked, to the numb-cold night?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("All this from my remembrance brutish wrath")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Sinfully pluck’d, and not a man of you")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Had so much grace to put it in my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But when your carters or your waiting-vassals")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Have done a drunken slaughter, and defac’d")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The precious image of our dear Redeemer,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You straight are on your knees for pardon, pardon;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And I, unjustly too, must grant it you:—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But for my brother not a man would speak,—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Nor I, ungracious, speak unto myself")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For him, poor soul. The proudest of you all")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Have been beholding to him in his life;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Yet none of you would once beg for his life.—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("O God, I fear Thy justice will take hold")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("On me, and you, and mine, and yours, for this!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Come, Hastings, help me to my closet.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Ah, poor Clarence!")])]), _c('p', {
    staticClass: "poem2"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Exeunt KING, QUEEN, HASTINGS, RIVERS, DORSET, and GREY.]")])])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: This is the fruit of rashness! Mark’d you not")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("How that the guilty kindred of the queen")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Look’d pale when they did hear of Clarence’ death?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("O, they did urge it still unto the king!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("God will revenge it.—Come, lords, will you go")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To comfort Edward with our company?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BUCKINGHAM; We wait upon your grace.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Exeunt.]")])])]), _c('h3', {
    staticClass: "ch-title",
    attrs: {
      "id": "lev2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene II. Another Room in the palace")])])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter the DUCHESS OF YORK, with A SON and DAUGHTER of CLARENCE.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SON: Good grandam, tell us, is our father dead?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: No, boy.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DAUGHTER: Why do you weep so oft, and beat your breast,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And cry “O Clarence, my unhappy son!”")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SON: Why do you look on us, and shake your head,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And call us orphans, wretches, castaways,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("If that our noble father were alive?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: My pretty cousins, you mistake me both;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I do lament the sickness of the king,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As loath to lose him, not your father’s death;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("It were lost sorrow to wail one that’s lost.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SON: Then you conclude, my grandam, he is dead.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The king mine uncle is to blame for this:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("God will revenge it; whom I will importune")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("With earnest prayers all to that effect.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DAUGHTER: And so will I.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Peace, children, peace! the king doth love you well:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Incapable and shallow innocents,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You cannot guess who caus’d your father’s death.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("SON: Grandam, we can; for my good uncle Gloster")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Told me, the king, provok’d to it by the queen,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Devis’d impeachments to imprison him:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And when my uncle told me so, he wept,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And pitied me, and kindly kiss’d my cheek;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Bade me rely on him as on my father,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And he would love me dearly as his child.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Ah, that deceit should steal such gentle shape,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And with a virtuous visard hide deep vice!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("He is my son; ay, and therein my shame;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Yet from my dugs he drew not this deceit.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SON: Think you my uncle did dissemble, grandam?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Ay, boy.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SON: I cannot think it.—Hark! what noise is this?")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter QUEEN ELIZABETH, distractedly; RIVERS and DORSET following her.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("QUEEN ELIZABETH: Ah, who shall hinder me to wail and weep,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To chide my fortune, and torment myself?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I’ll join with black despair against my soul,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And to myself become an enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: What means this scene of rude impatience?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: To make an act of tragic violence:—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Edward, my lord, thy son, our king, is dead.—")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Why grow the branches when the root is gone?")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Why wither not the leaves that want their sap?—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("If you will live, lament; if die, be brief,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That our swift-wingèd souls may catch the king’s;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Or, like obedient subjects, follow him")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To his new kingdom of perpetual rest.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Ah, so much interest have I in thy sorrow")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As I had title in thy noble husband!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I have bewept a worthy husband’s death,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And liv’d by looking on his images:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But now two mirrors of his princely semblance")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Are crack’d in pieces by malignant death,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And I for comfort have but one false glass,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That grieves me when I see my shame in him.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Thou art a widow, yet thou art a mother,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And hast the comfort of thy children left;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But death hath snatch’d my husband from mine arms,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And pluck’d two crutches from my feeble hands,—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Clarence and Edward. O, what cause have I,—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Thine being but a moiety of my moan,—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To overgo thy woes and drown thy cries?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SON: Ah, aunt, you wept not for our father’s death!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("How can we aid you with our kindred tears?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DAUGHTER: Our fatherless distress was left unmoan’d,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Your widow-dolour likewise be unwept!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: Give me no help in lamentation;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I am not barren to bring forth complaints:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("All springs reduce their currents to mine eyes,")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("That I, being govern’d by the watery moon,")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("May send forth plenteous tears to drown the world!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Ah for my husband, for my dear Lord Edward!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CHILDREN: Ah for our father, for our dear Lord Clarence!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Alas for both, both mine, Edward and Clarence!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: What stay had I but Edward? and he’s gone.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CHILDREN: What stay had we but Clarence? and he’s gone.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: What stays had I but they? and they are gone.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: Was never widow had so dear a loss!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("CHILDREN: Were never orphans had so dear a loss!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Was never mother had so dear a loss!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Alas, I am the mother of these griefs!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Their woes are parcell’d, mine is general.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("She for an Edward weeps, and so do I:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I for a Clarence weep, so doth not she:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("These babes for Clarence weep, and so do I;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I for an Edward weep, so do not they:—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Alas, you three, on me, threefold distress’d,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Pour all your tears! I am your sorrow’s nurse,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And I will pamper it with lamentation.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DORSET: Comfort, dear mother: God is much displeas’d")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That you take with unthankfulness His doing:")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("In common worldly things ‘Tis called ungrateful,")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("With dull unwillingness to repay a debt")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Which with a bounteous hand was kindly lent;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Much more to be thus opposite with heaven,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For it requires the royal debt it lent you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("RIVERS: Madam, bethink you, like a careful mother,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Of the young prince your son: send straight for him;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Let him be crown’d; in him your comfort lives.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Drown desperate sorrow in dead Edward’s grave,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And plant your joys in living Edward’s throne.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter GLOSTER, BUCKINGHAM, STANLEY, HASTINGS, RATCLIFF and others.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: Sister, have comfort: all of us have cause")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To wail the dimming of our shining star;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But none can help our harms by wailing them.—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Madam, my mother, I do cry you mercy;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I did not see your grace:—humbly on my knee")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I crave your blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: God bless thee; and put meekness in thy breast,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Love, charity, obedience, and true duty!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: Amen!")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Aside]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And make me die a good old man!—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That is the butt end of a mother’s blessing;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I marvel that her grace did leave it out.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("BUCKINGHAM: You cloudy princes and heart-sorrowing peers,")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("That bear this heavy mutual load of moan,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Now cheer each other in each other’s love:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Though we have spent our harvest of this king,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We are to reap the harvest of his son.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The broken rancour of your high-swoln hearts,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But lately splinter’d, knit, and join’d together,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Must gently be preserv’d, cherish’d, and kept;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Me seemeth good that, with some little train,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Forthwith from Ludlow the young prince be fetched")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Hither to London, to be crown’d our king.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("RIVERS: Why with some little train, my Lord of Buckingham?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("BUCKINGHAM: Marry, my lord, lest by a multitude,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The new-heal’d wound of malice should break out;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Which would be so much the more dangerous")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("By how much the estate is green and yet ungovern’d:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Where every horse bears his commanding rein")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And may direct his course as please himself,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As well the fear of harm as harm apparent,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("In my opinion, ought to be prevented.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: I hope the king made peace with all of us;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And the compact is firm and true in me.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("RIVERS: And so in me; and so, I think, in all:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Yet, since it is but green, it should be put")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To no apparent likelihood of breach,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Which haply by much company might be urg’d:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Therefore I say with noble Buckingham,")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("That it is meet so few should fetch the prince.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("HASTINGS: And so say I.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: Then be it so; and go we to determine")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Who they shall be that straight shall post to Ludlow.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Madam,—and you, my mother,—will you go")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To give your censures in this business?")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Exeunt all but BUCKINGHAM and GLOSTER.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("BUCKINGHAM: My lord, whoever journeys to the prince,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For God’d sake, let not us two stay at home;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For by the way I’ll sort occasion,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As index to the story we late talk’d of,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To part the queen’s proud kindred from the Prince.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("GLOSTER: My other self, my counsel’s consistory,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("My oracle, my prophet!—my dear cousin,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I, as a child, will go by thy direction.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Toward Ludlow then, for we’ll not stay behind.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Exeunt.]")])])]), _c('h3', {
    staticClass: "ch-title",
    attrs: {
      "id": "lev3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene III. London. A street")])])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter two CITIZENS, meeting.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("FIRST CITIZEN: Good morrow, neighbour: whither away so fast?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SECOND CITIZEN: I promise you, I scarcely know myself:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Hear you the news abroad?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FIRST CITIZEN: Yes,—that the king is dead.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SECOND CITIZEN: Ill news, by’r lady; seldom comes the better:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I fear, I fear ‘twill prove a giddy world.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter third CITIZEN.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("THIRD CITIZEN: Neighbours, God speed!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FIRST CITIZEN: Give you good morrow, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: Doth the news hold of good King Edward’s death?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SECOND CITIZEN: Ay, sir, it is too true; God help the while!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: Then, masters, look to see a troublous world.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FIRST CITIZEN: No, no; by God’s good grace, his son shall reign.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: Woe to that land that’s govern’d by a child!")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("SECOND CITIZEN: In him there is a hope of government,")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Which, in his nonage, council under him,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And, in his full and ripen’d years, himself,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("No doubt, shall then, and till then, govern well.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FIRST CITIZEN: So stood the state when Henry the Sixth")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Was crown’d in Paris but at nine months old.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: Stood the state so? No, no, good friends, God wot;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For then this land was famously enrich’d")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("With politic grave counsel; then the king")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Had virtuous uncles to protect his grace.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FIRST CITIZEN; Why, so hath this, both by his father and mother.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: Better it were they all came by his father,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Or by his father there were none at all;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For emulation who shall now be nearest")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Will touch us all too near, if God prevent not.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("O, full of danger is the Duke of Gloster!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And the queen’s sons and brothers haught and proud:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And were they to be rul’d, and not to rule,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("This sickly land might solace as before.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("FIRST CITIZEN: Come, come, we fear the worst; all will be well.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: When clouds are seen, wise men put on their cloaks;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("When great leaves fall, then winter is at hand;")])]), _c('p', {
    staticClass: "poem"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("When the sun sets, who doth not look for night?")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("Untimely storms make men expect a dearth.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("All may be well; but, if God sort it so,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v(" ‘Tis more than we deserve or I expect.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SECOND CITIZEN: Truly, the hearts of men are fun of fear:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You cannot reason almost with a man")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That looks not heavily and fun of dread.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: Before the days of change, still is it so:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("By a divine instinct men’s minds mistrust")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Ensuing danger; as, by proof, we see")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The water swell before a boisterous storm.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But leave it all to God.—Whither away?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("SECOND CITIZEN: Marry, we were sent for to the justices.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("THIRD CITIZEN: And so was I; I’ll bear you company.")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Exeunt.]")])])]), _c('h3', {
    staticClass: "ch-title",
    attrs: {
      "id": "lev4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene IV. London. A Room in the Palace")])])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter the ARCHBISHOP OF YORK, the young DUKE OF YORK, QUEEN ELIZABETH, and the DUCHESS OF YORK.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("ARCHBISHOP: Last night, I hear, they at Northampton lay;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And at Stony-Stratford they do rest to-night:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To-morrow or next day they will be here.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: I long with all my heart to see the prince:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I hope he is much grown since last I saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: But I hear no; they say my son of York")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Has almost overta’en him in his growth.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("YORK: Ay, mother; but I would not have it so.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Why, my good cousin? it is good to grow.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("YORK: Grandam, one night as we did sit at supper,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("My uncle Rivers talk’d how I did grow")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("More than my brother. “Ay,” quoth my uncle Gloster,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("“Small herbs have grace: great weeds do grow apace.”")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And since, methinks, I would not grow so fast,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Because sweet flowers are slow and weeds make haste.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Good faith, good faith, the saying did not hold")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("In him that did object the same to thee:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("He was the wretched’st thing when he was young,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("So long a growing and so leisurely,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That, if his rule were true, he should be gracious.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("ARCHBISHOP: And so no doubt he is, my gracious madam.")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: I hope he is; but yet let mothers doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("YORK: Now, by my troth, if I had been remember’d,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I could have given my uncle’s grace a flout")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("To touch his growth nearer than he touch’d mine.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: How, my young York? I pr’ythee let me hear it.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("YORK: Marry, they say my uncle grew so fast")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That he could gnaw a crust at two hours old:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("‘Twas full two years ere I could get a tooth.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Grandam, this would have been a biting jest.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: I pr’ythee, pretty York, who told thee this?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("YORK: Grandam, his nurse.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: His nurse! why she was dead ere thou wast born.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("YORK: If ‘twere not she, I cannot tell who told me.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: A parlous boy!—go to, you are too shrewd.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ARCHBISHOP: Good madam, be not angry with the child.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: Pitchers have ears.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ARCHBISHOP: Here comes a messenger.")])]), _c('p', {
    staticClass: "poem2"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Enter a MESSENGER.]")])])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("What news?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MESSENGER: Such news, my lord, as grieves me to report.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: How doth the prince?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MESSENGER: Well, madam, and in health.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: What is thy news?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MESSENGER: Lord Rivers and Lord Grey are sent to Pomfret,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("With them Sir Thomas Vaughan, prisoners.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Who hath committed them?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MESSENGER: The mighty dukes,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Gloster and Buckingham.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ARCHBISHOP: For what offence?")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("MESSENGER: The sum of all I can, I have disclos’d;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Why or for what the nobles were committed")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Is all unknown to me, my gracious lady.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: Ah me, I see the ruin of my house!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The tiger now hath seiz’d the gentle hind;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Insulting tyranny begins to jet")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Upon the innocent and aweless throne:—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Welcome, destruction, blood, and massacre!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I see, as in a map, the end of all.")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("DUCHESS: Accursèd and unquiet wrangling days")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("How many of you have mine eyes beheld?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("My husband lost his life to get the crown;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And often up and down my sons were toss’d")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For me to joy and weep their gain and loss:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And being seated, and domestic broils")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Clean over-blown, themselves, the conquerors")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Make war upon themselves; brother to brother,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Blood to blood, self against self: O, preposterous")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And frantic outrage, end thy damnèd spleen;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Or let me die, to look on death no more!")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: Come, come, my boy; we will to sanctuary.—")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Madam, farewell.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("DUCHESS: Stay, I will go with you.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("QUEEN ELIZABETH: You have no cause.")]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("ARCHBISHOP")]), _vm._v(" "), _c('p', {
    staticClass: "poem2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[To the queen.]")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("My gracious lady, go.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And thither bear your treasure and your goods.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("For my part, I’ll resign unto your grace")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The seal I keep; and so betide to me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As well I tender you and all of yours!")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Go, I’ll conduct you to the sanctuary.")])]), _c('p', {
    staticClass: "poem2"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("[Exeunt.]")])])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e0b550e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/04_Chapter02.vue
// module id = 81
// module chunks = 0